<template>
  <div class="container-fluid p-0">
    <p style="color: #009a78; cursor: pointer" @click="backToClusterPage">
      {{ "< Back" }} </p>
        <div class="row justify-content-end my-4">
          <div class="col-auto">
            <button class="btnCluster rtcBtn" @click="pushRTC">Push RTC</button>
          </div>
          <div class="col-auto">
            <button @click="goToAnalytics" class="btnCluster analyticsBtn">
              <analyticIcon />
              Data Analytics
            </button>
          </div>
        </div>
        <div class="row">
          <!-- class="col-auto" style="width: 324px; margin-top: 0; height: 1107px; z-index: 1" -->

          <div class="col-3 d-flex flex-column gap-4 mb-0 overflow-auto" style="height: 1110px">
            <!-- <div
          class="h-100 row justify-content-start align-content-start align-items-start"
        > -->
            <div v-bind:key="index" v-for="(item, index) in leftCard" class="flex-shrink-0" style="min-height: 165px">
              <!-- <div class="h-100"> -->
              <card class="h-100" type="small" :title="item.title" :subtitle="item.subtitle" :img="item.img"
                :value="item.value" :stacked="item.stacked" @open-light-modal="openLightModal"
                :lastseen="item.lastseen">
              </card>
              <!-- <LeftCards @open-light-modal="openLightModal" :cards="leftCard" /> -->
              <!-- </div> -->
            </div>
          </div>
          <div class="col g-4" style="margin-top: 0; height: 1107px; z-index: 1">
            <div class="row h-100">
              <div class="col-12 m-0 g-4">
                <div class="large-card p-0">
                  <LightMap v-if="markers && markers.length" v-model:markers="markers"
                    @on-fullscreen="openLightMapModal" />
                </div>
              </div>
              <div class="col-12 g-4">
                <div class="large-card p-0">
                  <ClusterMaster @on-change-scheduler="onChangeScheduler" @on-stop="onSliderStop" @on-click="onTekan"
                    :timerLeft="timerleft" :is-override="successOverride" :selected-duration="option" />
                </div>
              </div>
              <div class="col-12 g-4">
                <div class="large-card">
                  <VoltageChart :items="voltageChart" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto" style="width: 324px; margin-top: 0; height: 1107px; z-index: 1">
            <div class="h-100 row justify-content-start align-content-start align-items-start">
              <div class="col-12 m-0 g-4" style="height: 545px">
                <EventLogs :eventLogs="eventLogs" />
              </div>
              <div class="col-12 g-4 d-flex flex-column gap-4 mb-0 overflow-auto" style="height: 794px">
                <div v-bind:key="index" v-for="(item, index) in rightCard" class="flex-shrink-0"
                  style="min-height: 162px">
                  <card class="h-100" type="small" :img="item.img" :subtitle="item.subtitle" :title="item.title"
                    :value="item.value" @open-light-modal="openLightModal">
                  </card>
                </div>
                <!-- <RightCards :cards="" /> -->
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-6 g-4">
            <div class="large-card">
              <CurrentChart :items="currentChart" />
            </div>
          </div>
          <div class="col-6 g-4">
            <div class="large-card">
              <EnergyChart :items="energyChart" />
            </div>
          </div>
        </div>
        <div class="modal fade" id="successModal" tabindex="-1" role="dialog" aria-labelledby="successModal"
          data-bs-backdrop="static" aria-hidden="true">
          <SuccessModal :btnText="'Done'" :message="successMessage" :onSave="successSave" />
        </div>
        <div class="modal fade" id="warningModal" tabindex="-1" role="dialog" aria-labelledby="warningModal"
          data-bs-backdrop="static" aria-hidden="true">
          <WarningModal @onSave="warningSave"
            :note="'This user will no longer be available if you agree to proceed.'" />
        </div>
        <div class="modal fade" id="lightModal" tabindex="-1" role="dialog" aria-labelledby="lightModal"
          data-bs-backdrop="static" aria-hidden="true">
          <ListLightModal ref="lightModal" @close-modal="closeLightModal" />
        </div>
        <div class="modal fade" id="lightMapModal" tabindex="-1" role="dialog" aria-labelledby="lightMapModal"
          data-bs-backdrop="static" aria-hidden="true">
          <LightMapModal ref="lightMapModal" @close-modal="closeLightMapModal" />
        </div>

        <my-modal :visible="modal.showModal" :title="modal.title" :titledescription="modal.description"
          :message="modal.message" :type="modal.type" :showNote="modal.showNote" :showConfirm="modal.showConfirm"
          :showCancel="modal.showCancel" @confirm="handleConfirm" @cancel="handleCancel"
          :confirmMessageButton="modal.confirmMessageButton">
        </my-modal>
        <my-modal :visible="modal.showModalWarning" :title="modal.title" :titledescription="modal.description"
          :message="modal.message" :type="modal.type" :showNote="modal.showNote" :showConfirm="modal.showConfirm"
          :showCancel="modal.showCancel" @confirm="handleConfirmWarning" @cancel="handleCancelWarning"
          :confirmMessageButton="modal.confirmMessageButton">
        </my-modal>
  </div>
</template>
<script>
import { Modal } from "bootstrap";
import LeftCards from "./light/LeftCards.vue";
import RightCards from "./light/RightCards.vue";
import EventLogs from "./light/EventLogs.vue";
import CurrentChart from "./light/currentChart.vue";
import EnergyChart from "./light/energyChart.vue";
import VoltageChart from "./light/voltageChart.vue";
import LightMap from "./maps/maps/lightMap.vue";
import ClusterMaster from "./light/ClusterMaster.vue";
import ListLightModal from "./light/ListLightModal.vue";
import LightMapModal from "./light/LightMapModal.vue";
// import markerData from "../data/api/listMarker.json";
import SuccessModal from "./uikits/modal/SuccessModal.vue";
import WarningModal from "./uikits/modal/WarningModal.vue";
import moment from "moment";
import analyticIcon from "@/assets/svg/analytic-icon.vue";
import { formatTo2Decimal } from "@/utils";
import checkIcon from "@/assets/images/right.png";
import seruIcon from "@/assets/images/seru.png";

export default {
  components: {
    LeftCards,
    RightCards,
    EventLogs,
    CurrentChart,
    EnergyChart,
    VoltageChart,
    LightMap,
    ClusterMaster,
    ListLightModal,
    LightMapModal,
    SuccessModal,
    WarningModal,
    analyticIcon,
  },
  data() {
    return {
      option: "",
      modal: {
        showModal: false,
        showModalWarning: false,
        title: "SUCCESS !",
        description: "",
        message: "",
        type: "success", //warning,
        confirmMessageButton: "Done",
        showNote: true,
        showConfirm: true,
        showCancel: true,
      },
      successOverride: false,
      lightName: "",
      durationSelect: "",
      timerleft: "",
      markers: [],
      lightModal: null,
      lightMapModal: null,
      voltageChart: {
        Label: [],
        Data: [],
      },
      currentChart: {
        Label: [],
        Data: [],
      },
      energyChart: {
        Label: [],
        Data: [],
      },
      socket: null,
      leftCard: [],
      rightCard: [],
      eventLogs: [],
      successModal: null,
      successMessage: "",
      successSave: () => { },
      warningModal: null,
      warningSave: () => { },
    };
  },
  watch: {
    successOverride() { },
  },
  created() { },
  mounted() {
    // get override schduler timer
    this.getOverrideSchedulerTimer();

    this.sendStatusCommand();
    this.lightModal = new Modal(document.getElementById("lightModal"), {});
    const lightModalElement = document.getElementById("lightModal");
    lightModalElement.addEventListener("show.bs.modal", () => {
      this.$refs.lightModal.initializeModal();
    });

    this.connectSocket();
    this.getCardData();
    this.getChartData();

    // this.getMarkers();
    this.lightMapModal = new Modal(
      document.getElementById("lightMapModal"),
      {}
    );
    const lightMapModalElement = document.getElementById("lightMapModal");
    lightMapModalElement.addEventListener("show.bs.modal", () => {
      this.$refs.lightMapModal.initializeModal(this.markers);
    });

    this.successModal = new Modal(document.getElementById("successModal"), {});
    this.warningModal = new Modal(document.getElementById("warningModal"), {});
  },
  beforeUnmount() {
    // console.log("Component is about to unmount");
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    handleCancelWarning() {
      this.option = "";
      this.modal = {
        showModal: false,
        showModalWarning: false,
      };
    },
    getOverrideSchedulerTimer() {
      this.$http
        .get(":11004/api/v1/override/lights/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.successOverride = response.Status;
            this.timerleft = response.TimeEnd != "" ? response.TimeEnd : 0;
          }
        });
    },
    connectSocket() {
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":11000/ws/lights/" + this.$route.query.id
      );

      this.socket.onopen = () => {
        // console.log("web socket connected");
      };
      this.socket.onmessage = ({ data }) => {
        // console.log(JSON.parse(data));
        this.parseData(JSON.parse(data));
      };
    },
    parseData(data) {
      console.log({ data });
      this.leftCard = [
        {
          img: require("@/assets/images/icon/connection.png"),
          title: data.ConnectionStatus,
          subtitle: "Connection Status",
          lastseen:
            data?.LastSeenTime != null
              ? moment(data.LastSeenTime).fromNow()
              : "Never Seen",
        },
        {
          img: require("@/assets/images/icon/connection.png"),

          stacked: [
            {
              label: "Gateway to Node RSSI",
              value: data.RSSIGateWay != 0 ? "-" + data.RSSIGateWay : 0,
            },
            {
              label: "Node to Gateway RSSI",
              value: data.RSSIDevice != 0 ? "-" + data.RSSIDevice : 0,
            },
          ],
        },
        {
          img: require("@/assets/images/icon/signal.png"),
          title: data.SNRGateway + " dBm",
          subtitle: "SNR Value",
        },
        {
          img: require("@/assets/images/icon/light.png"),
          title: data.LightStatus,
          subtitle: "Light Status",
        },
        {
          img: require("@/assets/images/icon/light.png"),
          title: data.LightBrightness + " %",
          subtitle: "Light Brightness",
        },
        {
          img: require("@/assets/images/icon/energy.png"),
          title: data.LastVoltage + " V",
          subtitle: "Last Voltage",
        },
      ];

      this.rightCard = [
        {
          img: require("@/assets/images/icon/energy.png"),
          title: data.LastCurrent + " mA",
          subtitle: "Last Current",
        },
        {
          img: require("@/assets/images/icon/energy.png"),
          title: data.TotalEnergy + " kWh",
          subtitle: "Total Energy",
        },
        {
          img: require("@/assets/images/icon/schedule.png"),
          title: data.ScheduleProfile,
          subtitle: "Schedule Profile",
        },
      ];
    },
    handleConfirm() {
      this.modal = {
        showModal: false,
        showModalWarning: false,
      };
    },
    handleConfirmWarning() {
      this.$http
        .post(
          ":11004/api/v1/override/lights/" +
          this.$route.query.id +
          "/" +
          Math.floor(this.option / 60)
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            const { Status, Message } = response;
            if (Status === true) {
              this.successOverride = true;
            }

            this.modal = {
              showModal: true,
              showModalWarning: false,
              title: "SUCCESS!",
              description: Message,
              message: "",
              type: "success", //warning,
              confirmMessageButton: "Done",
              showNote: false,
              showConfirm: true,
              showCancel: false,
            };
            // this.successMessage = Message;
            // this.successSave = () => {
            //   this.successModal.hide();
            // };
            // this.successModal.show();
            // this.warningModal.hide();
          }
        });
    },
    handleCancel() {
      this.modal = {
        showModal: false,
      };
    },
    onChangeScheduler(option) {
      this.option = option;
      // console.log({ option });
      this.modal = {
        showModal: false,
        showModalWarning: true,
        title: "WARNING!",
        description: "Are you sure?",
        message:
          "This user will no longer be available if you agree to proceed.",
        confirmMessageButton: "Yes",
        type: "warning",
        showNote: true,
        showConfirm: true,
        showCancel: true,
      };

      // this.warningSave = () => {
      //   console.log({ timer: Math.floor(option / 60) });
      //   // set override scheduler
      //
      // };
      // this.warningModal.show();
    },
    onTekan(brightness, onoff, flag) {
      // console.log("trigger on tekan");
      this.sendCommand(brightness, onoff, flag);
    },
    onSliderStop(brightness, onoff, flag) {
      // console.log("trigger on slide");
      this.sendCommand(brightness, onoff, flag);
    },
    sendCommand(brightness, onoff, f) {
      // console.log("br", brightness);
      // console.log("onoff", onoff);
      // console.log(f);
      if (f != "timerhabis") {
        let status = onoff == true ? 1 : 0;
        let br = brightness / 10;
        // console.log("send command")
        // set brightness n off
        this.$http
          .post(
            ":11004/api/v1/lights/lights/" +
            this.$route.query.id +
            "/" +
            status +
            "/" +
            br
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.successMessage = response.Message;

              this.successSave = () => this.successModal.hide();
              this.successModal.show();
            }
          });
      }
    },

    pushRTC() {
      this.$http
        .post(":11004/api/v1/rtc/lights/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.$swal({
              title: `<div class="success-title"><img src="${checkIcon}" alt="check" /><p class="header">SUCCESSFUL!</p></div><p class="success-text">${response}</p>`,

              confirmButtonText: "Done",

              customClass: {
                title: "swal2-content",
                popup: "success-popup swal2-content",
                confirmButton: "success-button",
              },
              buttonsStyling: false,
            });
            // // console.log(response);
            // this.successMessage = "RTC push successful";
            // // console.log(this.successSave);
            // this.successSave = () => {
            //   this.successModal.hide();
            // };
            // // console.log(this.successSave);
            // this.successModal.show();
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            "Something went wrong. Please try again.";

          this.$swal({
            title: `<div class="warning-title"><img src="${seruIcon}" alt="check" /><p class="header">WARNING!</p></div>`,
            html: `<p class="warning-subtitle">Note</p><p class="warning-subtitle2">${message}</p>`,
            // showCancelButton: true,
            confirmButtonText: "OK",
            // cancelButtonText: "No",
            customClass: {
              title: "swal2-content",
              popup: "warning-popup swal2-content",
              confirmButton: "warning-button",
              // cancelButton: "warning-cancel-button",
            },
            buttonsStyling: false,
          }).then((result) => {
            console.log(result);
          });
        });
    },
    sendStatusCommand() {
      this.$http
        .post(":11004/api/v1/status/lights/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // console.log(response);
          }
        });
    },
    getCardData() {
      this.$http
        .get(":11000/api/v1/light/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.lightName = response.DeviceName;
            this.setHeaderComponent();
            // get latlng
            this.markers = [
              {
                latLng: [response.Latitude, response.Longitude],
                id: response.DeviceID,
                name: response.DeviceName,
                icon: "LightsOffline",
                lat: 1.563512,
                long: 110.364646,
              },
            ];

            // event log
            this.eventLogs = [];
            if (response.EventLog != null) {
              for (var i = 0; i < response.EventLog.length; i++) {
                let obj = {
                  time: moment(response.EventLog[i].EventTime).format("HH:mm"),
                  date: moment(response.EventLog[i].EventTime).format(
                    "YYYY-MM-DD"
                  ),
                  methods: response.EventLog[i].Method,
                  log: response.EventLog[i].EventDescription,
                };
                this.eventLogs.push(obj);
              }
            }
          }
        });
    },
    getChartData() {
      this.$http
        .get(":11000/api/v1/light/graphs/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            // console.log(response);

            // Voltage graph
            let formattedVoltageData = formatTo2Decimal(
              response.GraphVoltage.AvgGraph
            );
            let formattedVoltageDate = response.GraphVoltage.Period.map(
              (date) => moment(date).format("HH:mm")
            );

            this.voltageChart = {
              Label: formattedVoltageDate,
              Data: formattedVoltageData,
            };

            // Current graph
            let formattedCurrentData = formatTo2Decimal(
              response.GraphCurrent.AvgGraph
            );
            let formattedCurrentDate = response.GraphCurrent.Period.map(
              (date) => moment(date).format("HH:mm")
            );

            this.currentChart = {
              Label: formattedCurrentDate,
              Data: formattedCurrentData,
            };

            // Energy graph
            let formattedEnergyData = formatTo2Decimal(
              response.GraphEnergy.AvgGraph
            );
            let formattedEnergyDate = response.GraphEnergy.Period.map((date) =>
              moment(date).format("HH:mm")
            );

            this.energyChart = {
              Label: formattedEnergyDate,
              Data: formattedEnergyData,
            };
          }
        });
    },
    goToAnalytics() {
      this.$route.query.flag = "light";
      this.$router.push({
        path: "analytics",
        query: this.$route.query,
      });
    },
    openLightModal() {
      this.lightModal.show();
    },
    closeLightModal() {
      this.lightModal.hide();
    },
    openLightMapModal() {
      this.lightMapModal.show();
    },
    closeLightMapModal() {
      this.lightMapModal.hide();
    },
    openClusterMapModal() {
      this.clusterMapModal.show();
    },
    closeClusterMapModal() {
      this.clusterMapModal.hide();
    },
    backToClusterPage() {
      window.location.href = "/cluster?id=" + this.$route.query.clusterId;
    },
    // getMarkers() {
    //   this.markers = markerData.message.markers.map((item) => {
    //     return {
    //       ...item,
    //       latLng: [item.lat, item.long],
    //     };
    //   });
    // },
    setHeaderComponent() {
      console.log(this.lightName);

      // window.location.href = "/cluster?id=" + this.$route.query.clusterId

      this.$store.dispatch("common/setHeaderComponent", {
        title: "Light Page - " + this.lightName,
        subtitle: "",
        // showBack: true,
        // backUrl: "/cluster?id=" + this.$route.query.clusterId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: #009a78;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 32px;
}

.cluster-page {
  padding: 0;
}

.btnCluster {
  display: flex;
  height: 44px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #218863;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.rtcBtn {
  width: 130px;
  color: #218863;
  background: #fff;

  :hover {
    background: #218863;
    color: #fff;
  }
}

.analyticsBtn {
  width: 150px;
  color: #fff;
  background: #218863;
}
</style>
<style lang="scss">
.info {
  width: 25px;
  height: 25px;
  background: #fff;
  border: 2px solid #1daeef;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 15px;
  top: 15px;
  color: #1daeef;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
}

.large-card {
  height: 353px;
  padding: 35px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);

  .green {
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(142deg, #bcefdb 41.95%, #a0cce7 96.79%);
    box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);
  }
}

.card-small {
  height: 160px !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25) !important;

  .card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 19px 15px 19px 35px !important;
  }

  .card-footer {
    padding: 13px 16px !important;
    color: #1daeef;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    span {
      cursor: pointer;
    }
  }

  .widget-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .image {
    min-width: 63px;
    min-height: 63px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: var(--Gradient,
        linear-gradient(142deg, #bcefdb 29.66%, #a0cce7 96.79%));

    img {
      scale: 0.667;
      object-fit: contain;
    }
  }

  .title {
    margin: 0;
    color: #ababab;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: pre-line;

    strong {
      color: #000;
      text-shadow: 0px 4px 8px rgba(215, 227, 235, 0.25);
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }

    p {
      color: #009a78;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }
  }

  .subtitle {
    margin: 0;
    color: #ababab;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: pre-line;
  }

  .card-footer {
    border-top: 1px solid #e9e9e9;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 60px;
  }
}
</style>
